/**
 * @generated SignedSource<<75c2c9b54a80f04b71e7ff47b44ede22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PreviewSendSlackMessageInput = {
  organizationId?: string | null;
  richEditorBody: string;
  sendAs?: string | null;
};
export type MessageCommunityMembersFormPreview_SlackMessageMutation$variables = {
  input: PreviewSendSlackMessageInput;
};
export type MessageCommunityMembersFormPreview_SlackMessageMutation$data = {
  readonly response: {
    readonly data: boolean | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type MessageCommunityMembersFormPreview_SlackMessageMutation = {
  response: MessageCommunityMembersFormPreview_SlackMessageMutation$data;
  variables: MessageCommunityMembersFormPreview_SlackMessageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PreviewSendSlackMessageResponse",
    "kind": "LinkedField",
    "name": "previewSendSlackMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageCommunityMembersFormPreview_SlackMessageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MessageCommunityMembersFormPreview_SlackMessageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b0f4a5922a16865ad477b39553b4105f",
    "id": null,
    "metadata": {},
    "name": "MessageCommunityMembersFormPreview_SlackMessageMutation",
    "operationKind": "mutation",
    "text": "mutation MessageCommunityMembersFormPreview_SlackMessageMutation(\n  $input: PreviewSendSlackMessageInput!\n) {\n  response: previewSendSlackMessage(input: $input) {\n    data\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "be545e052edd3e190cb99bd54a6fa420";

export default node;
